import { Box, Button, HStack, Icon } from "@chakra-ui/react";
import { TbLayoutRows, TbLayoutGrid } from "react-icons/tb";
import type { DensityMode } from "../types";

interface Props {
  density: DensityMode;
  onChange: (next: DensityMode) => void;
}

/**
 * Segmented control for matrix density. Gray pill with a white "raised"
 * active button — no blue. Sits next to the gear button in the page header.
 */
export default function DensityToggle({ density, onChange }: Props) {
  return (
    <Box
      bg="gray.100"
      borderRadius="md"
      p="2px"
      display="inline-flex"
    >
      <HStack spacing={0}>
        <Segment
          icon={TbLayoutRows}
          label="Expanded"
          active={density === "comfortable"}
          onClick={() => onChange("comfortable")}
        />
        <Segment
          icon={TbLayoutGrid}
          label="Compact"
          active={density === "compact"}
          onClick={() => onChange("compact")}
        />
      </HStack>
    </Box>
  );
}

function Segment({
  icon, label, active, onClick,
}: {
  icon: typeof TbLayoutRows;
  label: string;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <Button
      onClick={onClick}
      size="xs"
      h="22px"
      px={2.5}
      fontSize="12px"
      fontWeight="normal"
      bg={active ? "white" : "transparent"}
      color={active ? "gray.800" : "gray.600"}
      borderRadius="md"
      boxShadow={active ? "0 1px 2px rgba(0,0,0,0.06)" : "none"}
      leftIcon={<Icon as={icon} boxSize={3.5} />}
      _hover={{ bg: active ? "white" : "gray.200" }}
      _active={{ bg: active ? "white" : "gray.200" }}
    >
      {label}
    </Button>
  );
}
